module.exports = __webpack_public_path__ + "static/media/drag_the_items_to_add_up_to_healthy_teeth.8d34ff3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/drag_the_items_to_add_up_to_healthy_teeth.mp3
// module id = /p5N
// module chunks = 0